const RECOVERY_PREFIX = "useSave:recovery:"
const RECOVERY_TTL = 24 * 60 * 60 * 1000

function getRecoveryEmail() {
    return window._authorization?.user?.attributes?.email ?? window._authorization?.user?.email ?? "anonymous"
}

function getRecoveryKey(id) {
    return `${RECOVERY_PREFIX}${getRecoveryEmail()}:${id}`
}

export function persistRecovery(id, target) {
    if (!id) return
    try {
        localStorage.setItem(getRecoveryKey(id), JSON.stringify({ target, timestamp: Date.now() }))
    } catch (e) {
        // localStorage full or unavailable — fail silently
    }
}

export function clearRecovery(id) {
    if (!id) return
    try {
        localStorage.removeItem(getRecoveryKey(id))
    } catch (e) {
        // fail silently
    }
}

export function loadRecovery(id) {
    if (!id) return null
    try {
        const key = getRecoveryKey(id)
        const raw = localStorage.getItem(key)
        if (!raw) return null
        const { target, timestamp } = JSON.parse(raw)
        if (Date.now() - timestamp > RECOVERY_TTL) {
            localStorage.removeItem(key)
            return null
        }
        return target
    } catch (e) {
        // Remove corrupt entry so it doesn't cause repeated parse failures
        try {
            localStorage.removeItem(getRecoveryKey(id))
        } catch (_) {
            // fail silently
        }
        return null
    }
}

export function retryDelay(attempt, base = 1000, max = 16000) {
    return Math.min(base * 2 ** (attempt - 1), max)
}

if (window.Cypress) {
    window.__USE_SAVE_RECOVERY__ = { persistRecovery, loadRecovery, clearRecovery }
}
